import { env } from '@ria-client/env';

export function generateSrcSet({
  dprs = [1.5, 2, 3],
  quality = 85,
  source,
  height,
  width,
  inverse,
}: {
  dprs?: number[];
  quality?: number;
  source?: string;
  height: number;
  width: number;
  inverse?: boolean;
}) {
  if (!source) return;
  if (source.endsWith('.svg')) return source;

  const ratios = inverse ? dprs.reverse() : dprs;
  return ratios
    .map((d, i) => {
      const url = new URL(source);

      if (!url.hostname.includes('nerdwallet')) {
        return null;
      }

      let updatedUrl = source
        .replace(/width=\d+/, '')
        .replace(/height=\d+/, '')
        .replace(/quality=\d+/, '')
        .replace(/dpr=\d+/, '')
        .replace(/format=\s+/, '')
        .replace(/resize=/, '')
        .replace('cdn-cgi/image/', '')
        .replace('https://www.nerdwallet.com', '')
        .replace('https://stage.nerdwallet.biz', '')
        .replace('/,/', '/');

      if (!updatedUrl.startsWith('/')) {
        updatedUrl = `/${updatedUrl}`;
      }

      const adjustedWidth = inverse ? width / (dprs[i] as number) : width;
      const adjustedHeight = inverse ? height / (dprs[i] as number) : height;

      const path = `${env.NEXT_PUBLIC_NW_URL}/cdn-cgi/image/width=${adjustedWidth},height=${adjustedHeight},quality=${quality},format=webp,fit=contain,dpr=${d},${updatedUrl}`;
      return path ? `${path} ${dprs[i]}x` : '';
    })
    .filter(Boolean)
    .join(', ');
}
